import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';

import { WebcamModule } from 'ngx-webcam';

import { SelectedDocsModule } from '../selected-docs/selected-docs.module';
import { IbWebcamComponent } from './webcam.component';

@NgModule({
  declarations: [IbWebcamComponent],
  imports: [
    CommonModule,
    SelectedDocsModule,
    WebcamModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  exports: [IbWebcamComponent],
})
export class IbWebcamModule {}
